import React, { useContext } from 'react';

const ModalDialogGrowWithContentContext = React.createContext<undefined | boolean>(undefined);

export const useModalDialogGrowWithContentContext = () => useContext(ModalDialogGrowWithContentContext);

export default ModalDialogGrowWithContentContext;
